import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { get, set, del } from 'idb-keyval';

/**
 * IndexedDB-backed query cache persister. Survives reloads so the
 * dashboard renders the last-good content while a slow / offline /
 * cold network is catching up.
 *
 * The buster string is the SHA-256 of the active session password
 * — when it changes (sign-out / rotation) the cache is invalidated
 * because the persisted blob's signature won't match.
 */
export function createIDBPersister(buster: string) {
  return createAsyncStoragePersister({
    key: `houseops:queries:${buster}`,
    storage: {
      getItem: (k) => get(k).then((v) => (typeof v === 'string' ? v : null)),
      setItem: (k, v) => set(k, v),
      removeItem: (k) => del(k),
    },
  });
}
